// BL-241 Gate 2 — the raw conversation_log / raw_message_log JSON views, moved out of the main
// communications panel and behind a "View technical log ↗" button. Read-only: this renders the
// same two arrays the panel used to print inline, nothing more.

import React from 'react';

function TechnicalLogModal({ intakeSession, onClose, theme = 'light' }) {
    const dark = theme === 'dark';
    const panelCls = dark ? 'bg-gray-800 border-gray-600 text-gray-100' : 'bg-white border-gray-200 text-gray-800';
    const labelCls = dark ? 'text-gray-400' : 'text-gray-500';
    const dividerCls = dark ? 'border-gray-700' : 'border-gray-100';
    const preCls = dark ? 'bg-gray-900 text-gray-300' : 'bg-gray-50 text-gray-700';

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center p-6" onClick={onClose}>
            <div
                role="dialog"
                aria-label="Technical log"
                className={`w-full max-w-3xl rounded-xl border shadow-2xl ${panelCls}`}
                style={{ maxHeight: '85vh', overflowY: 'auto' }}
                onClick={(event) => event.stopPropagation()}
            >
                <div className={`flex items-start justify-between p-5 border-b ${dividerCls}`}>
                    <div>
                        <h3 className="text-base font-semibold">Technical log</h3>
                        <p className={`text-xs mt-0.5 ${labelCls}`}>Raw AI Attendant turns and provider audit trail for this session.</p>
                    </div>
                    <button onClick={onClose} className={`text-lg leading-none p-1 rounded hover:bg-gray-200/40 ${labelCls}`} aria-label="Close technical log">✕</button>
                </div>
                <section className="p-5">
                    <h4 className="text-xs font-semibold uppercase tracking-wide mb-2">Conversation Log</h4>
                    <pre className={`text-xs whitespace-pre-wrap break-words rounded-lg p-3 ${preCls}`}>{JSON.stringify(intakeSession?.conversation_log || [], null, 2)}</pre>
                </section>
                <section className={`p-5 pt-0`}>
                    <h4 className="text-xs font-semibold uppercase tracking-wide mb-2">Raw Message Log</h4>
                    <pre className={`text-xs whitespace-pre-wrap break-words rounded-lg p-3 ${preCls}`}>{JSON.stringify(intakeSession?.raw_message_log || [], null, 2)}</pre>
                </section>
            </div>
        </div>
    );
}

export default TechnicalLogModal;
